import Box from '@mui/material/Box';

import { Logo } from 'src/components/logo';
import Typography from '@mui/material/Typography';


export const SplashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 1400
    }}
  >
    <Box
      sx={{
        display: 'inline-flex',
        height: 48,
        width: 48
      }}
    >
      <Logo />
    </Box>
    <Typography
      sx={{
        color: 'text.secondary',
        mt: 3
      }}
      variant="h8"
    >
      Build a Sustainable Future with PortFi
    </Typography>
  </Box>
);
